import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { dataTable } from 'client/helpers/dataTables';

/**
 * Renders a red badge if at least 1 item exists in the specified data table view.
 */
@dataTable((props) => ({
  dataSource: props.dataTableSource,
  viewId: props.dataTableViewId,
  skipInitialize: true,
}))
class SrDataTableIndicatorBadge extends Component {
  static propTypes = {
    dataTableSource: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
    dataTableViewId: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
    items: PropTypes.array.isRequired,
  };

  render() {
    const { items } = this.props;
    return items.length === 0 ? null : <div className="SrDataTableIndicatorBadge" />;
  }
}

SrDataTableIndicatorBadge.displayName = 'SrDataTableIndicatorBadge';

export default SrDataTableIndicatorBadge;
